import { t } from '../i18n';
import { useMe } from '../lib/auth';
import { can } from '../lib/permissions';
import { PortalHome } from './PortalHome';
import { TechDashboard } from './tickets/TechDashboard';

/** Inicio: para IT, su panel de tickets (guía 7.1); para el resto, el portal con lo que viene a hacer. */
export function HomePage() {
  const me = useMe();
  if (can(me, 'tickets.gestionar')) {
    return (
      <div className="space-y-4">
        <h1 className="text-2xl font-semibold text-tinta">{t('inicio.saludo', { nombre: me.fullName.split(' ')[0] ?? me.fullName })}</h1>
        <TechDashboard />
      </div>
    );
  }
  return <PortalHome />;
}
